@import '~style-sheet-helpers/core.less';
@import '../../../constants/spacing.module.less';

.column-wrapper {
  display: flex;
  align-items: center;
}

.icon {
  width: 24px;
  height: 24px;
  padding: @space-4;

  &.is-warning {
    color: var(--warning--icon--fill-color--2);
  }
  &.is-error {
    color: var(--error--icon--fill-color--1);
  }
}
